
import { trackLoginImpression, trackRegTrigger } from '@/plugins/hwtag/events'
export default {
  name: 'AuthUser',
  props: {
    /** 与 xfans_header 中 dialogSize / isMobile 一致：窄屏为 true */
    is_mobile: {
      type: Boolean,
      default: false,
    },
    showPasswordFree: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuVisible: false,
    }
  },
  methods: {
    onAvatarEnter() {
      if (!this.is_mobile) {
        trackLoginImpression('曝光', '顶部导航')
        this.menuVisible = true
      }
    },
    onAvatarLeave() {
      if (!this.is_mobile) {
        this.menuVisible = false
      }
    },
    onAvatarClick() {
      if (this.is_mobile) {
        trackLoginImpression('曝光', '顶部导航')
        this.menuVisible = !this.menuVisible
      }
    },
    openPasswordFree() {
      trackRegTrigger('点击', '顶部导航', 'Password-free')
      this.menuVisible = false
      this.$emit('open-password-free')
    },
    openLoginDialog() {
      this.menuVisible = false
      this.$emit('open-login')
    },
    openRegisterDialog() {
      trackRegTrigger('点击', '顶部导航', 'Sign up')
      this.menuVisible = false
      this.$emit('open-register')
    },
  },
}
